import { render, staticRenderFns } from "./multas-prazo-listagem.vue?vue&type=template&id=2f9a5047&scoped=true&"
import script from "./multas-prazo-listagem.vue?vue&type=script&lang=js&"
export * from "./multas-prazo-listagem.vue?vue&type=script&lang=js&"
import style0 from "./multas-prazo-listagem.vue?vue&type=style&index=0&id=2f9a5047&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9a5047",
  null
  
)

export default component.exports